import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const buttonDefaultVariants = {
  "appearance": "secondary",
  "size": "standard",
  "disabled": false,
  "busy": false
}
const buttonCompoundVariants = []

const buttonSlotNames = [
  [
    "main",
    "Button__main"
  ],
  [
    "spinner",
    "Button__spinner"
  ],
  [
    "content",
    "Button__content"
  ]
]
const buttonSlotFns = /* @__PURE__ */ buttonSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, buttonDefaultVariants, getSlotCompoundVariant(buttonCompoundVariants, slotName))])

const buttonFn = memo((props = {}) => {
  return Object.fromEntries(buttonSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const buttonVariantKeys = [
  "appearance",
  "size",
  "disabled",
  "busy"
]
const getVariantProps = (variants) => ({ ...buttonDefaultVariants, ...compact(variants) })

export const button = /* @__PURE__ */ Object.assign(buttonFn, {
  __recipe__: false,
  __name__: 'button',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: buttonVariantKeys,
  variantMap: {
  "appearance": [
    "primary",
    "secondary",
    "danger",
    "text",
    "contrast"
  ],
  "size": [
    "small",
    "standard",
    "large"
  ],
  "disabled": [
    "false",
    "true"
  ],
  "busy": [
    "false",
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, buttonVariantKeys)
  },
  getVariantProps
})